if (typeof isMobile === 'undefined') {
    var isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;
}
if (isMobile) {
    $(".modal3d").hide();
}
else {
    $(".3d-modal-mobile").hide();
}